import { T, Var } from 'gt-react';
import type { LinkLoad } from '@erp/rpc';
import { Badge } from '@/components/ui/badge';

/**
 * How a direct load ran, for load history and batch history: an "SQL" badge
 * for a SQL-mode load, or why SQL mode was declined when it was asked for and
 * the load ran in chunks. Nothing for an ordinary chunked load.
 */
export function LoadModeNote({
  mode,
  declinedReason,
}: {
  mode: LinkLoad['mode'] | null;
  declinedReason: string | null;
}) {
  if (mode === 'sql') {
    return (
      <Badge variant="outline" className="text-xs">
        <T context="badge on a direct load that ran in SQL mode (set-based SQL instead of chunks)">
          SQL
        </T>
      </Badge>
    );
  }
  if (!declinedReason) return null;
  return (
    <span
      className="block max-w-[20rem] basis-full truncate text-xs text-muted-foreground"
      title={declinedReason}
    >
      <T context="note on a direct load asked for in SQL mode that ran in chunks instead, with the reason">
        SQL mode declined: <Var>{declinedReason}</Var>
      </T>
    </span>
  );
}
